import React from 'react';
import PropTypes from 'prop-types';

const Network = ({ network }) =>
  network.map(item => {
    const { name, logo } = item;
    return (
      <span key={`${name}-${logo}`}>
        <img src={logo} title={name} alt={name} />
      </span>
    );
  });

export default Network;
Network.defaultProps = {
  network: [],
};

Network.propTypes = {
  network: PropTypes.arrayOf(PropTypes.shape({})),
};
